import { Component } from '@angular/core';

@Component({
  selector: 'app-vat-codes',
  templateUrl: './vat-codes.component.html',
  styleUrls: ['./vat-codes.component.scss'],
})
export class VatCodesComponent {}
